import { render, staticRenderFns } from "./MatchSides.vue?vue&type=template&id=5f1f2bd0&scoped=true&"
import script from "./MatchSides.vue?vue&type=script&lang=js&"
export * from "./MatchSides.vue?vue&type=script&lang=js&"
import style0 from "./MatchSides.vue?vue&type=style&index=0&id=5f1f2bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f2bd0",
  null
  
)

export default component.exports